import BaseObjectDirective from './BaseObjectDirective';

/**
 * AsfVideoObjectCtrl is a controller class that extends BaseObjectDirective.
 * It handles the functionality related to video objects in the application.
 */
export class AsfVideoObjectCtrl extends BaseObjectDirective {
    /**
     * Constructor for AsfVideoObjectCtrl.
     * @param {Object} $scope - Angular scope object.
     * @param {Object} $injector - Angular injector service.
     * @param {Object} $uibModal - Angular UI Bootstrap modal service.
     * @param {Object} $rootScope - Angular root scope.
     * @param {Object} $routeParams - Angular route parameters.
     * @param {Object} TaskDataService - Service for task data operations.
     * @param {Object} $signals - Signal service for event handling.
     * @param {Object} $timeout - Angular timeout service.
     * @param {Object} SheetLoadedService - Service to handle sheet loading.
     * @param {Object} $q - Angular promise service.
     * @param {Object} IAAPreferencesService - Service for IAA preferences.
     */
    constructor($scope, $injector, $uibModal, $rootScope, $routeParams, TaskDataService, $signals, $timeout, SheetLoadedService, $q, IAAPreferencesService) {
        super($injector, $scope);
        
        this.$scope = $scope;
        this.$injector = $injector;
        this.$uibModal = $uibModal;
        this.$rootScope = $rootScope;
        this.$routeParams = $routeParams;
        this.TaskDataService = TaskDataService;
        this.$signals = $signals;
        this.$timeout = $timeout;
        this.SheetLoadedService = SheetLoadedService;
        this.$q = $q;
        this.IAAPreferencesService = IAAPreferencesService;

        
        this.$scope.isStimulus = true;

        this.$scope.isCMS = this.$rootScope.isCMS;
        this.$scope.prefsMode = false;
        this.$scope.hasBrowseImage = true;
        this.$scope.hasBrowseSubtitle = true;

        this.$scope.mediaObject = undefined;

        this.$scope.taskuuid = this.$routeParams.taskUUID;

        
        this.big_container = this.$scope.$parent.rows ? this.$scope.$parent.rows[this.$scope.$parent.rowKey].cols.length == 1 : true;
        this.videoSizes = {
            'big': [
                '640x360',
                '864x486',
                '919x517',
                'Original'
            ],
            'small': [
                '320x180',
                '416x234',
                'Original'
            ]
        };
        const ctrl = this;
        
        this.updateMediaObject = () => {
            this.$scope.mediaObject = this.$scope.contentObject.getContentReference(false);
            if (this.$scope.mediaObject) {
                this.$scope.video = this.$scope.$parent.loadObjectUrl ? this.$scope.mediaObject.getMediaURL(this.$scope.taskuuid) : '/';
                this.$scope.subtitleOnPlay = this.$scope.contentObject.getPreferences().showSubtitleOnPlay;
        
                var iaaPreferences = this.IAAPreferencesService.getPreferences();
                if (iaaPreferences.videoSubtitleAutoEnable && iaaPreferences.videoSubtitleAutoEnable === true) {
                    this.$scope.subtitleOnPlay = iaaPreferences.videoSubtitleAutoEnable;
                }
        
                if (this.$scope.contentObject.getContent() != '') {
                    this.$scope.subtitle = this.TaskDataService.fetchContext().read(this.$scope.contentObject.getContent());
                    this.$scope.removeSubtitle = true;
                } else {
                    this.$scope.subtitle = undefined;
                    this.$scope.removeSubtitle = false;
                }
            }
        };
        

        this.updateMediaObject();
        

        /**
         * Returns the video size based on the type (width or height).
         * @param {string} type - The type of size to return ('width' or 'height').
         * @returns {number} - The size of the video.
         */
        this.$scope.getVideoSize = (type) => {
            var height = 0,
                width = 0;

            var prefDisplaySize = this.$scope.contentObject.getPreferences().displaySize || undefined;
            if (typeof prefDisplaySize != 'undefined' && prefDisplaySize != 'Original') {
                width = prefDisplaySize.split('x')[0];
                height = prefDisplaySize.split('x')[1];
            } else {
                if (this.$scope.mediaObject) {
                    width = this.$scope.mediaObject.getWidth();
                    height = this.$scope.mediaObject.getHeight();

                    var colWidth = this.big_container ? 919 : 416;
                    if (width > colWidth)
                        width = colWidth;
                }
            }

            var ret = width;
            if (type == 'height')
                ret = height;

            if (!ret)
                if (type == 'height')
                    ret = 240;
                else
                    ret = 428;

            return ret;
        };

        this.parentContainer = this.$scope.$parent.containerObj;

        /**
         * Initializes the preferences for the video object.
         */
        this.$scope.initPreferences = () => {
            var displaySize = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().displaySize : undefined);
            var showSubtitleOnPlay = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().showSubtitleOnPlay : undefined);
            var includedInPDF = (typeof this.$scope.contentObject.getPreferences() !== "undefined" ? this.$scope.contentObject.getPreferences().includedInPDF : "disabled");
            var targetHintObject = (typeof this.$scope.contentObject.getPreferences() != "undefined" ? this.$scope.contentObject.getPreferences().targetHintObject : undefined);

            this.$scope.$watch('preferencesValues', (val1, val2) => {
                if (val1 == val2)
                    return;
                var preferences = {};
                angular.forEach(this.$scope.preferencesValues, (value, key) => {
                    preferences[key] = value;
                });
                this.$scope.contentObject.setPreferences(preferences);
            }, true);

            this.prefSizes = this.big_container ? this.videoSizes['big'] : this.videoSizes['small'];

            if (this.prefSizes.indexOf(displaySize) < 0 && typeof displaySize != 'undefined')
                this.$scope.contentObject.setPreference('displaySize', this.prefSizes[this.prefSizes.length - 1]);

            this.$scope.preferencesValues = {};
            this.$scope.preferencesValues['displaySize'] = displaySize;
            this.$scope.preferencesValues['showSubtitleOnPlay'] = showSubtitleOnPlay;
            this.$scope.preferencesValues['includedInPDF'] = typeof includedInPDF !== 'undefined' ? includedInPDF : "disabled";
            this.$scope.preferencesValues['targetHintObject'] = targetHintObject;

            this.$scope.preferences = [
                {
                    'displaySize': [
                        {'type': 'select', 'name': 'Display Size:', 'options': this.prefSizes, 'valueKey': 'displaySize'}
                    ],
                    'showSubtitleOnPlay': [
                        {'type': 'checkbox', 'name': 'Show subtitles on videostart? ', 'valueKey': 'showSubtitleOnPlay'}
                    ],
                    'includedInPDF': [
                        {'type': 'checkbox', 'name': 'Included in Response PDF', 'valueKey': 'includedInPDF'}
                    ],
                    'targetHintObject': [{
                        'type': 'select-other-content-object',
                        'name': ' link this Object as Hint',
                        'valueKey': 'targetHintObject',
                        'objectType': 'hint',
                        'parentContainer': this.parentContainer
                    }]
                },
            ];
        };

        this.$scope.initPreferences();

        /**
         * Opens the media modal for browsing videos.
         */
        this.$scope.onMediaBrowseButtonClick = () => {
            this.$scope.openMediaModal('video');
        };

        /**
         * Opens the media modal for adding subtitles.
         */
        this.$scope.onMediaAddSubtitleButtonClick = () => {
            this.$scope.openMediaModal('subtitle');
            this.updateMediaObject();;
        };

        /**
         * Deletes the subtitle for the video.
         */
        this.$scope.onMediaDeleteSubtitleButtonClick = () => {
            this.$scope.contentObject.setContent('');
            this.$scope.subtitle = undefined;
            this.$scope.removeSubtitle = false;
            this.updateMediaObject();
        };

        this.modalInstance = null;
        /**
         * Opens the media modal for the specified type (video or subtitle).
         * @param {string} type - The type of media to open the modal for.
         */
        this.$scope.openMediaModal = (type) => {
            this.modalInstance = this.$uibModal.open({
                templateUrl: '/views/ib/cms/eassessment/modal/eassessmentmediabrowserModal.html',
                controller: function ($scope, $uibModalInstance, contentObjectUUID) {
                    $scope.showonly = type;
                    $scope.contentobjectuuid = contentObjectUUID;

                    $scope.onModalCloseButtonClick = function() {
                        $uibModalInstance.dismiss('cancel');                        
                    };
                },
                scope: this.$scope,
                resolve: {
                    'contentObjectUUID': () => {
                        return this.$scope.contentObject.getUUID();
                    }
                }
            });
        };

        var _tmp = this.$scope.resetChanges;
        /**
         * Resets the changes made to the preferences.
         */
        this.$scope.resetChanges = () => {
            _tmp();
            this.$scope.preferencesValues['displaySize'] = this.$scope.contentObject.getPreference('displaySize');
        };

        /**
         * Handles the selection of media.
         * @param {Object} selectedMedia - The selected media object.
         */
        this.onSelectMedia = (selectedMedia) => {
            if (selectedMedia.contentobjectuuid == this.$scope.contentObject.getUUID()) {
                var media = this.TaskDataService.fetchContext().read(selectedMedia.uuid),
                    mt = media.getMimeType(),
                    isSubtitle = mt.indexOf('x-subrip') >= 0 || mt == 'text/plain';

                if (isSubtitle)
                    this.$scope.contentObject.setContent(selectedMedia.uuid);
                else
                    this.$scope.contentObject.setContentReference(selectedMedia.uuid);

                if (this.modalInstance !== null) {
                    this.modalInstance.close();
                }
            }
            ctrl.updateMediaObject();
        };

        /**
         * Removes the event listener when the scope is destroyed.
         */
        this.$scope.$on('$destroy', () => {
            this.$signals.remove(IB.Signals.CMS_MEDIA_OBJECT_SELECTED, this.onSelectMedia);
        });

        this.$signals.on(IB.Signals.CMS_MEDIA_OBJECT_SELECTED, this.onSelectMedia);

        var _d = this.$q.defer();
        this.SheetLoadedService.wait(_d.promise, 'video');
        this.$timeout(() => {
            if (this.$scope.$parent.element.find('iframe').length > 0) {
                this.$scope.$parent.element.find('iframe').load(() => {
                    _d.resolve('video');
                });
            } else {
                _d.resolve('video');
            }
        });
    }
}

/**
 * Registers the AsfVideoObject directive.
 * @param {Object} module - The Angular module to register the directive with.
 */
export default function registerAsfVideoObjectDirective(module) {
    module.directive('asfVideoObject', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                "contentObject": "="
            },
            templateUrl: "/views/ib/contentobjects/video.html",
            controller: AsfVideoObjectCtrl
        };
    });
    registerContentObject(module);
}

/**
 * Registers the content object in the ContentObjectRegistryService.
 * @param {Object} module - The Angular module to register the content object with.
 */
export function registerContentObject(module) {
    module.run(['ContentObjectRegistryService', function(ContentObjectRegistryService) {
        var obj = [{
            "uuid": "",
            "content": "",
            "objectType": "video",
            "type": "contentObject",
            "contentReference": false,
            "preferences": {
                "displaySize": undefined,
                "showSubtitleOnPlay": false,
                "includedInPDF": "disabled"
            }
        }];
        var objProperties = {
            type: "video",
            label: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.VIDEO.LABEL',
            cssClass: "new-video-object",
            icon: "cms/icon-video.png",
            description: 'CMS.LAYOUT-MANAGER.NEW-OBJECT.VIDEO.DESCRIPTION',
            group: {
                id: 2
            }
        };
        ContentObjectRegistryService.register(obj, objProperties);
    }]);
}